import { SolDialogState } from '../abstract-dialog-component.directive';
import { SolDialog, SolDialogType } from '../../../models/core/sol-dialog';
import { SolValidationMessage } from '../../../models/core/sol-validation-message';
import { SolText } from '../../../models/core/sol-text';
import { ObjectTools } from '../../../tools/object-tools';

export class SolConfirmDialogState implements SolDialogState {
  private constructor(
    public readonly dialog: SolDialog,
    public readonly text: SolText,
    public readonly messages: SolValidationMessage[],
  ) {}

  public static of(): SolConfirmDialogState {
    return new SolConfirmDialogState(SolDialog.ofConfirm(SolText.empty()), SolText.empty(), []);
  }

  public withDialog(dialog: SolDialog): this {
    return ObjectTools.copy<SolConfirmDialogState>(this, { dialog }) as this;
  }

  public withText(text: SolText): SolConfirmDialogState {
    if (ObjectTools.equals(this.text, text)) {
      return this;
    }
    return ObjectTools.copy<SolConfirmDialogState>(this, { text });
  }

  public withMessages(messages: SolValidationMessage[]): SolConfirmDialogState {
    return ObjectTools.copy<SolConfirmDialogState>(this, { messages });
  }

  public withConfig(title: SolText, text: SolText, confirmText?: SolText, type?: SolDialogType): SolConfirmDialogState {
    let dialog = SolDialog.ofConfirm(title, confirmText);
    if (type) {
      dialog = dialog.withType(type);
    }
    return ObjectTools.copy<SolConfirmDialogState>(this, { dialog, text });
  }
}
